import {
  ORDER_RATING_REQUEST,
  ORDER_RATING_SUCCESS,
  ORDER_RATING_FAILURE,
  ORDER_RATING_DISMISS_REQUEST,
  ORDER_RATING_DISMISS_SUCCESS,
  ORDER_RATING_DISMISS_FAILURE,
} from '../../actions/types';

const initialState = {
  loading: false,
  error: undefined,
};

export default function ordersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ORDER_RATING_REQUEST:
    case ORDER_RATING_DISMISS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ORDER_RATING_SUCCESS:
    case ORDER_RATING_DISMISS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case ORDER_RATING_FAILURE:
    case ORDER_RATING_DISMISS_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
